import React, { useContext } from 'react';
import { Context } from 'components/Store';
import GrowUIFormField from 'components/Forms/GrowUIFormField';
import { TextArea } from '@agconnections/grow-ui';

const ShortDescription = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  return (
    <GrowUIFormField
      control={TextArea}
      type="text"
      id="shortDescription"
      name="shortDescription"
      label="Short Description"
      disabled={!isEnableInfoTabEdit}
      placeholder="Enter short description"
    />
  );
};

export default ShortDescription;
